import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
  },
});

store.subscribe(() => {
  try {
    localStorage.setItem('authState', JSON.stringify(store.getState().auth));
  } catch (error) {
    // ignore write errors
  }
});

export default store;
